import { makeAutoObservable, reaction } from "mobx";
import { Tracking } from "./Tracking";
export class FulfillmentSettingsTracking {
    constructor(params) {
        this.eventsDisposer = [];
        this.page = params.page;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        makeAutoObservable(this);
    }
    initialize() {
        this.initializeEvents();
    }
    initializeEvents() {
        if (this.eventsDisposer.length !== 0) {
            throw new Error("FulfillmentSettingsTracking events has been already initialized");
        }
        if (this.fulfillmentInstructions.type == "Online") {
            this.eventsDisposer.push(reaction(() => this.fulfillmentInstructions.fulfillmentMethodType, (fulfillmentMethodType) => {
                switch (fulfillmentMethodType) {
                    case "Delivery":
                        return Tracking.trackEvent({
                            tag: "ChooseDelivery",
                            contents: { page: this.page },
                        });
                    case "Takeaway":
                        return Tracking.trackEvent({
                            tag: "ChooseTakeaway",
                            contents: { page: this.page },
                        });
                    case "DineIn":
                        return Tracking.trackEvent({
                            tag: "ChooseDineIn",
                            contents: { page: this.page },
                        });
                }
            }));
            let firstChangeForAddress = true;
            this.eventsDisposer.push(reaction(() => this.fulfillmentInstructions.streetAddress !== null &&
                this.fulfillmentInstructions.streetAddress.checkoutData, () => {
                if (firstChangeForAddress) {
                    Tracking.trackEvent({
                        tag: "ChooseAddress",
                        contents: { page: this.page },
                    });
                    firstChangeForAddress = false;
                }
            }));
            let firstChangeForTime = true;
            this.eventsDisposer.push(reaction(() => this.fulfillmentInstructions.fulfillmentTime, () => {
                if (firstChangeForTime) {
                    Tracking.trackEvent({
                        tag: "ChooseDate",
                        contents: { page: this.page },
                    });
                    firstChangeForTime = false;
                }
            }));
        }
    }
    dispose() {
        if (this.eventsDisposer !== null) {
            this.eventsDisposer.forEach((event) => event());
            this.eventsDisposer = [];
        }
    }
}
